import React from 'react'

import { twMerge } from 'tailwind-merge'

import { COLOR_CLASSNAMES } from '@/constants/color'

import type { Color } from '@/types/Color'

interface ColorIndicatorProps {
  color: Color
  className?: string
}

export const ColorIndicator: React.FC<ColorIndicatorProps> = ({
  color,
  className,
}) => {
  return (
    <div
      className={twMerge(
        'flex-shrink-0 w-[11px] h-[11px] rounded-full',
        COLOR_CLASSNAMES[color],
        className,
      )}
    />
  )
}
